module.exports = __webpack_public_path__ + "static/crema-de-poro-y-papa-1-3899c91a7c0e1dbf1c405965da73706a.jpg";